// NPM Pacakges
import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Loader } from "./components";

//Styling
import './index.css';

//Files
import App from './App';


//Initialized DOM
ReactDOM.render(
    <div>
        <App />
        <Loader />
    </div>,
    document.getElementById("root")
);
